import { isThenable as i } from "./index123.js";
var f = function() {
  var n, e, o = 0;
  return {
    done: function() {
      return n;
    },
    run: function(t) {
      var r = t();
      return i(r) && (++o === 1 && (n = new Promise(function(u) {
        return e = u;
      })), r.finally(function() {
        return --o === 0 && e();
      })), r;
    }
  };
};
export {
  f as createTaskGroup
};
//# sourceMappingURL=index96.js.map
